import PropTypes from "prop-types";
import React, { ReactElement } from "react";
import { useParams } from "react-router";
import ShopLayout from "../Layout";
import SingleProduct from "../../Product/Details";
import { useSelector } from "react-redux";
import BreadCrumb from "../../Layouts/Breadcrumb";

const ShopProductDetails = (): ReactElement => {
  const { shopInfo } = useSelector((state) => (state as any)?.authReducer);
  return (
    <React.Fragment>
        <div className="content-body p-0 rounded-2xl">
          <SingleProduct inShop={true} />
        </div>
    </React.Fragment>
  );
};

ShopProductDetails.propTypes = {
  match: PropTypes.object,
  params: PropTypes.object,
};
export default ShopProductDetails;
